/* Change this file to get your personal Portfolio */
// Deploy with: netlify deploy

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Gaston Sweeten",
  title: "Hello, I'm Gaston",
  subTitle: emoji(
    "A Senior Software Engineer with 15+ years building scalable applications across mobile, web, and 3D visualization 🚀 Deep expertise in Android & Kotlin, with a passion for graphics, emerging tech, and shipping products that delight users."
  ),
  resumeLink:
    "https://docs.google.com/document/d/1BlSxKBv_vbVynztcFOK7qRBwStLmsYX3/edit?usp=sharing&ouid=105085852438979552678&rtpof=true&sd=true", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  //github: "https://github.com/saadpasta",
  linkedin: "https://www.linkedin.com/in/gaston-sweeten-83a36992/",
  gmail: "gsweeten@gmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "SENIOR FULL STACK ENGINEER SPECIALIZING IN ANDROID, WEB, AND 3D VISUALIZATION",
  skills: [
    emoji(
      "⚡ 15+ years architecting and shipping Android, web, and cross-platform mobile applications at scale"
    ),
    emoji(
      "⚡ Deep graphics expertise — OpenGL, GLSL shaders, WebGL, and real-time 3D engines (Unity3D, Godot, Unreal Engine)"
    ),
    emoji(
      "⚡ Full-stack development spanning Kotlin Multiplatform, React/Node.js, cloud infrastructure (AWS), and CI/CD pipelines"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Figma",
      fontAwesomeClassname: "fab fa-figma"
    },
    {
      skillName: "SQL / PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "3D Graphics / OpenGL",
      fontAwesomeClassname: "fas fa-cubes"
    },
	{
      skillName: "Unity",
      fontAwesomeClassname: "fab fa-unity"
    },
	{
      skillName: "AI Tools",
      fontAwesomeClassname: "fas fa-robot"
    },
	{
      skillName: "Jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "DigiPen Institute of Technology",
      logo: require("./assets/images/digipenLogo.png"),
      subHeader: "BS in Real-Time Interactive Simulation (Computer Science), Mathematics Minor",
      duration: "2004 - 2008",
      desc: "Rigorous computer science curriculum focused on real-time systems, graphics programming, and interactive simulation.",
      descBullets: [
        "Core coursework in graphics programming, linear algebra, physics simulation, and operating systems",
        "Hands-on game and simulation project development throughout the program"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Android / Mobile",
      progressPercentage: "95%"
    },
    {
      Stack: "3D Graphics & Engines",
      progressPercentage: "85%"
    },
    {
      Stack: "Frontend / Web",
      progressPercentage: "80%"
    },
    {
      Stack: "Backend / Cloud",
      progressPercentage: "75%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Development Engineer",
      company: "Amazon",
      companylogo: require("./assets/images/amazonLogo.png"),
      date: "November 2025 – Present",
      desc: "Took ownership of major feature areas of a Kotlin Multiplatform application serving field technicians.",
      descBullets: [
        "Implemented new technician device installation flows with runtime-configurable, remotely defined UI screens",
        "Collaborated with backend teams on API design to support new application features",
        "Built unit and integration tests for CI pipelines and performed QA across Android and iOS devices"
      ]
    },
    {
      role: "Senior Development Engineer",
      company: "STEER Tech",
      companylogo: require("./assets/images/steerLogo.jpg"),
      date: "October 2023 – October 2025",
      desc: "Led development of customer-facing analytics and real-time vehicle visualization tools for an autonomous vehicle fleet.",
      descBullets: [
        "Designed and built a customer facing analytics portal processing 10k+ vehicle data points daily",
        "Built a real-time vehicle sensor visualization app in Godot with custom GLSL shaders for Android tablet displays",
		"Built iOS vehicle tester app for logging of vehicle test case results"
      ]
    },
    {
      role: "Senior Android Engineer (SMTS)",
      company: "Salesforce",
      companylogo: require("./assets/images/salesforceLogo.png"),
      date: "March 2017 – October 2023",
      desc: "Founding Android team member for Salesforce Mobile Publisher, a app generation platform enabling extensive customer brand customization.",
      descBullets: [
        "Enabled feature customization through conditionally compiled components in the app generation pipeline",
		"Ensured quality by expanding CI/CD pipeline to include Espresso integration tests run on physical devices",
        "Acted as release manager, verified requirements, ran release tests, and published to Google Play Store"
      ]
    },
    {
      role: "Software Development Engineer",
      company: "NBC Universal",
      companylogo: require("./assets/images/nbcuLogo.png"),
      date: "September 2014 – March 2017",
      desc: "Took ownership of the Breaking News Android app (500,000+ installs).",
      descBullets: [
		"Performed major updates to app systems and visuals to reliably display the latest articles",
        "Independently developed Android widgets to improve user engagement and grow audience",
        "Led migration and team training for major codebase updates to Android Studio and Kotlin"
      ]
    },
    {
      role: "Design Developer",
      company: "Microsoft",
      companylogo: require("./assets/images/microsoftLogo.png"),
      date: "April 2013 – September 2014",
      desc: "Built UI components for the Xbox One companion app SmartGlass for Android (5M+ installs).",
      descBullets: [
        "Implemented device-independent UI for phones and tablets across all screen sizes and devices",
        "Advocated for design best practices within the development team and communicated Android technical constraints to designers"
      ]
    },
    {
      role: "Software Developer",
      company: "ICD",
      companylogo: require("./assets/images/icdLogo.PNG"),
      date: "September 2009 – April 2013",
      desc: "Worked across mobile, automotive, AR, and Kinect platforms delivering a wide range of interactive applications.",
      descBullets: [
        "Designed, tested, and implemented Kinect-powered 3D UIs and games with hand tracking as a Microsoft consultant",
        "Architected and implemented the frontend system for the McLaren MP4-12C automotive infotainment system",
        "Designed, built, and released casual mobile game Suburban Cowboy for Android and iOS",
        "Built stereoscopic 3D OpenGL applications for prototype AR smart glasses"
      ]
    },
    {
      role: "Assistant Programmer",
      company: "Big Huge Games",
      companylogo: require("./assets/images/bighugegamesLogo.png"),
      date: "May 2008 – November 2008",
      desc: "Contributed to game content tooling and systems on a AAA game development team.",
      descBullets: [
        "Designed and implemented C# game content creation tools including quest, NPC customization, and game object tools",
        "Implemented game system features including NPC customization and UI improvements"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME COMPANIES AND STARTUPS THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/leoImage.png"),
      projectName: "LEO Field Technician App",
      projectDesc: "Multiplatform mobile application to assist with the installation, servicing and inventory management of LEO equipment.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://leo.amazon.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/customerPortal.png"),
      projectName: "STEER Customer Portal",
      projectDesc: "Vehicle analytics portal for customers to view autonomous fleet's milage, savings, and more.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://steer-tech.com/"
        }
      ]
    },
    {
      image: require("./assets/images/mobilePublisher.png"),
      projectName: "Salesforce Mobile Publisher",
      projectDesc: "Low code application generation pipeline and Playground testing application.",
      footerLink: [
        {
          name: "Demo Video",
          url: "https://www.youtube.com/watch?v=LIXtI2jzRlo"
        },
        {
          name: "Visit Website",
          url: "https://help.salesforce.com/s/articleView?id=xcloud.s1_branded_apps.htm&type=5"
        },
        {
          name: "Playground App",
          url: "https://play.google.com/store/apps/details?id=com.mysalesforce.mycommunity.playgroundcommunity&hl=en_US"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/breakingNews.png"),
      projectName: "Breaking News",
      projectDesc: "Mobile news app frequently reviewed as the fastest source of reliable real-time breaking news",
      footerLink: [
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Production ML Systems Course",
      subtitle:
        "Completed Google's Production ML systems module of the Machine Learning Crash Course",
      image: require("./assets/images/productionMLSystemBadge.png"),
      imageAlt: "Google Production ML Systems Badge",
      footerLink: [
        {
          name: "Machine Learning Crash Course: Production ML systems",
          url: "https://developers.google.com/profile/badges/playlists/machine-learning-crash-course/production-ml-systems"
        }
      ]
    },

    {
      title: "Salesforce Certified Platform Administrator",
      subtitle: "Completed Salesforce Certified Platform Administrator course",
      image: require("./assets/images/sfCertifiedPlatformAdminBadge.png"),
      imageAlt: "Salesforce Certified Platform Administrator Badge",
      footerLink: [
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "gsweeten@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
